import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[rentalCurrencyIcon]',
  standalone: true
})
export class CurrencyIconDirective implements OnChanges {
  @Input('rentalCurrencyIcon') value: number = 0;
  @Input() iconColor: 'white' | 'black' = 'black'; // default

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    const value = this.value ?? 0;
    // Format to 2 decimal places and remove trailing zeros
    const formattedValue = parseFloat(value.toFixed(2));
    let formatted = formattedValue.toString();
    
    // Add comma formatting for values >= 10000
    if (formattedValue >= 10000) {
      const parts = formatted.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      formatted = parts.join('.');
    }

    this.renderer.setProperty(this.el.nativeElement, 'textContent', formatted);

    // Remove both potential classes first
    this.renderer.removeClass(this.el.nativeElement, 'currency-icon-black');
    this.renderer.removeClass(this.el.nativeElement, 'currency-icon-white');

    // Add the class according to the color
    const classToAdd = `currency-icon-${this.iconColor}`;
    this.renderer.addClass(this.el.nativeElement, classToAdd);
  }
}